var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72953 7.875C2.26562 7.875 1 6.75 1 4.78125V1.96875H3.53125",
    stroke: "#111111",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6561 1.96875H16.1874V4.78125C16.1874 6.75 14.9217 7.875 13.4592 7.875",
    stroke: "#111111",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 14.9062V12.9375",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 11.5312C7.25109 11.5312 5.96342 10.9979 5.01402 10.0485C4.06462 9.09907 3.53125 7.81141 3.53125 6.46875V0.84375H13.6562V6.46875C13.6562 7.81141 13.1229 9.09907 12.1735 10.0485C11.2241 10.9979 9.93641 11.5312 8.59375 11.5312V11.5312Z",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65625 17.1562C4.65625 15.9137 5.5 14.9062 7.46875 14.9062H9.71875C11.6875 14.9062 12.5312 15.9137 12.5312 17.1562H4.65625Z",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4883 9H6.58984V8.22656L8.42969 6.26562C8.68229 5.98958 8.86849 5.7487 8.98828 5.54297C9.11068 5.33724 9.17188 5.14193 9.17188 4.95703C9.17188 4.70443 9.10807 4.50651 8.98047 4.36328C8.85286 4.21745 8.67057 4.14453 8.43359 4.14453C8.17839 4.14453 7.97656 4.23307 7.82812 4.41016C7.68229 4.58464 7.60938 4.8151 7.60938 5.10156H6.47656C6.47656 4.75521 6.55859 4.4388 6.72266 4.15234C6.88932 3.86589 7.1237 3.64193 7.42578 3.48047C7.72786 3.31641 8.07031 3.23438 8.45312 3.23438C9.03906 3.23438 9.49349 3.375 9.81641 3.65625C10.1419 3.9375 10.3047 4.33464 10.3047 4.84766C10.3047 5.12891 10.2318 5.41536 10.0859 5.70703C9.9401 5.9987 9.6901 6.33854 9.33594 6.72656L8.04297 8.08984H10.4883V9Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy2);
export default ForwardRef;